<template>

			<div class="content">
		        <div class="container-fluid">
		        	<div class="row">
			            <div class="col-md-12">
			              <div class="card">
			                <div class="card-header card-header-info">
			                  <h4 class="card-title ">Tambah Kang Tagih</h4>
							</div>
			                <div class="card-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Nama Kang Tagih</label>
                                                <input type="text" class="form-control" placeholder="Nama Admin..." v-model="nama">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Username <span class="text-info">* Pastikan Username Unik</span></label>
                                                <input type="text" class="form-control" placeholder="Username..." v-model="username">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Password</label>
                                                <input type="text" class="form-control" placeholder="Password..." v-model="password">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Area <button class="btn btn-sm btn-primary" @click="modalArea = true">Tambah Area</button></label>
                                                <input type="text" class="form-control" placeholder="Nama Area..." v-model="area">
												<small class="text-info">* bisa di tambahkan beberapa area</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
			                    <div class="row">
			                      <div class="col-md-12">
			                        <div class="form-group">
                                        <button class="btn btn-primary" @click="Simpan">Simpan</button>
										<div class="alert alert-info" role="alert" v-show="alert">
											{{alertText}}
										</div>
			                        </div>
			                      </div>
			                    </div>
			                </div>
			              </div>
			            </div>
		        	</div>
		    	</div>
				
			<!-- MODAL -->
					<div class="modal" tabindex="-1" role="dialog" v-show="modalArea">
						<div class="overlay"></div>
						<div class="modal-dialog" role="document">
							<div class="modal-content">
								<div class="modal-header">
									<h5 class="modal-title">Pilih Area</h5>
									<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="modalArea = false">
									<span aria-hidden="true">&times;</span>
									</button>
								</div>
								<div class="modal-body">
									<div class="row">
						<div class="col-md-12">
						<div class="table-responsive" style="height:400px;oveflow:auto">
							<table class="table">
							<thead class=" text-info">
								<th>No.</th>
								<th>Nama</th>
								<th>Jumlah</th>
								<th>Aksi</th>
							</thead>
							<tbody>
								<tr v-for="(u, index) in areaList">
								<td>{{ index+1 }}</td>
								<td>{{ u.nama }}</td>
								<td>{{ u.jumlah }}</td>
								<td>
									<button class="btn btn-sm btn-primary" @click="pilihArea(u.id,u.nama)"> Pilih</button>
								</td>
								</tr>
							</tbody>
							</table>
						</div>
						</div>
									</div>
								</div>
							</div>
						</div>
					</div>
		    </div>
</template>

<script>

import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { url } from '@/var/var.js'
import inter from '@/globalFunc/Interface' 
import router from '@/router'

var numeral = require("numeral");

Vue.use(moment)

export default {
	components: { 
		vuejsDatepicker,
		moment,
	}, 
  	data() {
		return {
			title: "Detail Servis",
			nama: '',
			password: '',
			username: '',
			area: '',
			areaId: '',
			areaList: [],	
			modalArea: false,

			alert: false,
			alertText: "",
		}
	},
	methods: {
		pilihArea(id,nama) {
			var areaInput = this.area;

			if (areaInput.indexOf(nama) === -1) {
				if (areaInput == "") {
					this.area = nama;
					this.areaId = id;
				} else {
					this.area = this.area + ", " + nama;
					this.areaId = this.areaId + "," + id;
				}
			}
		},
		getArea() {
			// for filter
			var data = new FormData();
			data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
			data.append('type', "lunas");
			data.append('bulan', "0");
			
      		var apiUrl = inter.ListArea(); // 'ListArea';
			this.PostData(data,apiUrl).then(x => {
				if (x.status) {
					this.areaList = x.data;
				} else {
				//alert(x.pesan);
				}
			})
		},
        Simpan() {
			if (this.areaId == "") {
				this.alert = true;
				this.alertText = "Area tidak boleh kosong";
				return false;
			}

			this.alert = false;

			var datax = {
				token: 'TangTung '+sessionStorage.getItem('myToken'),
				nama: this.nama,
				area: this.areaId,
				password: this.password,
				username: this.username
			}
			
            var apiUrl = inter.AdminTambah();
            
			this.PostData(datax,apiUrl).then(x => {
				//this.loger(x);
				if (x.status) {
				    this.alert = false;
						router.push({ 
							name: 'admin-kangtagih'
						});
				} else {
				    this.alert = true;
				    this.alertText = x.pesan;
				}
			})
        }
	},
	mounted() {
        document.title = "Tambah Admin";

		this.getArea();
	}
}
</script>

<style scoped>
.edit-input {
	font-size: 20pt !important;
}
.file-upload {
    opacity: 1 !important;
    position: relative !important;
    z-index: 0 !important;
}
.modal {
	display: inherit;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/kangtagih/tambah.vue